import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { documentAPI } from '../services/api';
import { useAuth } from '../context/AuthContext';
import Swal from 'sweetalert2';
import './DocumentViewer.css';

const DocumentViewer = () => {
  const { qrCode } = useParams();
  const navigate = useNavigate();
  const { user, isAuthenticated } = useAuth();
  const [document, setDocument] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [pdfUrl, setPdfUrl] = useState('');
  const [downloading, setDownloading] = useState(false);



  useEffect(() => {
    if (qrCode) {
      fetchDocument();
    }
  }, [qrCode]);

  const fetchDocument = async () => {
    try {
      setLoading(true);
      setError('');

      const response = await documentAPI.getDocumentByQR(qrCode);
      setDocument(response.data.document);

      // Tạo URL để hiển thị PDF
      const apiUrl = process.env.REACT_APP_API_URL || 'https://apiqldangkyxe.nguyenluan.vn';
      setPdfUrl(`${apiUrl}/api/documents/public/${qrCode}/download`);
    } catch (error) {
      console.error('Fetch document error:', error);
      setError(error.response?.data?.message || 'Không thể tải tài liệu');
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async () => {
    try {
      setDownloading(true);

      const response = await documentAPI.downloadDocumentByQR(qrCode);

      // Tạo blob URL và trigger download
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = document.originalName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download error:', error);
      Swal.fire({
        icon: 'error',
        title: 'Lỗi!',
        text: 'Lỗi khi tải xuống tài liệu',
        confirmButtonColor: '#1e3a8a'
      });
    } finally {
      setDownloading(false);
    }
  };

  const handleAddDocument = () => {
    if (!isAuthenticated) {
      // Lưu URL hiện tại để redirect sau khi login
      localStorage.setItem('redirectAfterLogin', '/documents-list');
      navigate('/login');
    } else if (user && (user.role === 'admin' || user.role === 'document' || user.role === 'unit')) {
      // Đã đăng nhập và có quyền, chuyển đến trang danh sách tài liệu
      navigate('/documents-list');
    } else {
      Swal.fire({
        icon: 'warning',
        title: 'Không có quyền',
        text: 'Bạn không có quyền thêm tài liệu',
        confirmButtonColor: '#1e3a8a'
      });
    }
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('vi-VN', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return (
      <div className="document-viewer">
        <div className="loading">
          <div className="loading-spinner"></div>
          <p>Đang tải tài liệu...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="document-viewer">
        <div className="error">
          <h2>Lỗi</h2>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="document-viewer">
      {/* Header */}
      <div className="viewer-header">
        <div className="document-info">
          <h1>{document.title}</h1>
          <div className="document-meta">
            <span>Kích thước: {formatFileSize(document.fileSize)}</span>
            <span>Ngày upload: {formatDate(document.uploadDate)}</span>
            <span>Lượt tải: {document.downloadCount}</span>
          </div>
        </div>
        <div className="header-actions">
          <button
            className="btn-download"
            onClick={handleDownload}
            disabled={downloading}
          >
            {downloading ? 'Đang tải...' : 'Tải xuống'}
          </button>
          <button
            className="btn-upload"
            onClick={handleAddDocument}
          >
            Thêm tài liệu
          </button>
        </div>
      </div>



      {/* PDF Viewer - Hiển thị trực tiếp trong iframe */}
      <div className="pdf-container">
        <iframe
          src={pdfUrl}
          title={document.title}
          className="pdf-iframe"
          style={{ border: 'none' }}
        >
          <p>Trình duyệt của bạn không hỗ trợ hiển thị PDF.
            <a href={pdfUrl} target="_blank" rel="noopener noreferrer">
              Nhấn vào đây để tải xuống
            </a>
          </p>
        </iframe>
      </div>
    </div>
  );
};

export default DocumentViewer;
